import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';

import { useAvatarWithFullScreenPresenter } from './AvatarWithFullScreen.presenter';
import styles from './AvatarWithFullScreen.styles.m.css';

interface IAvatarWithFullScreenProps {
  className?: string;
  url?: string;
  dataTest?: string;
}

export const AvatarWithFullScreen: FC<PropsWithChildren<IAvatarWithFullScreenProps>> = observer(
  ({ className, children, url, dataTest }) => {
    const presenter = useAvatarWithFullScreenPresenter(url);

    return (
      <button
        className={classNames(styles.button, className)}
        disabled={!presenter.isClickable}
        data-test={dataTest}
        onClick={presenter.openFullScreen}
      >
        {children}
      </button>
    );
  }
);
